import BaseDecorator from "./BaseDecorator";
import OrderedProductOrderFieldDecorator from "./OrderedProductOrderFieldDecorator";
import OrderedProductPricelistItemDecorator from "./OrderedProductPricelistItemDecorator";

export default class OrderCustomerParticipantDecorator extends BaseDecorator {
  constructor({ display_name, ...data }) {
    super({
      ...data,

      ordered_product_pricelist_item:
        data.ordered_product_pricelist_item &&
        new OrderedProductPricelistItemDecorator(data.ordered_product_pricelist_item),

      ordered_product_order_fields: data.ordered_product_order_fields
        .map((x) => new OrderedProductOrderFieldDecorator(x))
        .sort((a, b) => a.product_order_field.position - b.product_order_field.position),
    });
  }

  get display_name() {
    if (this.ordered_product_pricelist_item) {
      return (
        I18n.t("activerecord.attributes.order_customer_participant.display_name", { i: this.position }) +
        ` (${this.ordered_product_pricelist_item.product_pricelist_item.display_name})`
      );
    } else {
      return I18n.t("activerecord.attributes.order_customer_participant.display_name", { i: this.position });
    }
  }

  get real_display_name() {
    if (this.full_name) {
      if (this.ordered_product_pricelist_item) {
        return this.full_name + ` (${this.ordered_product_pricelist_item.product_pricelist_item.display_name})`;
      } else {
        return this.full_name;
      }
    } else {
      return this.display_name;
    }
  }

  get full_name() {
    return this.getPresetOrderFieldValue("participant_full_name");
  }

  getPresetOrderFieldValue(preset_id) {
    const orderedField = (this.ordered_product_order_fields || []).find(
      (orderedField) => orderedField.product_order_field.preset_id === preset_id
    );
    return orderedField ? orderedField.value : null;
  }

  get priced_ordered_fields() {
    return this.ordered_product_order_fields
      .filter((orderedField) => orderedField.visible)
      .filter((orderedField) => orderedField.product_order_field.has_pricing);
  }

  get customer_ordered_fields() {
    return this.ordered_product_order_fields
      .filter((orderedField) => orderedField.visible)
      .filter((orderedField) => !orderedField.product_order_field.has_pricing);
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/OrderCustomerParticipantDecorator.js